import React, { useEffect } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { useRecoilState } from 'recoil';
import IconButton from '@material-ui/core/IconButton';
import CancelIcon from '@material-ui/icons/Cancel';
import { makeStyles } from '@material-ui/core/styles';

import { reminderTypeTabListState, reminderTypeTabIndexState, IReminderType } from '../store/ReminderTypeStore';
import ReminderTypeDetail from './Detail';
import ContentsWrapper from '../../../Public/Wrapper/ContentsWrapper';
import Header from '../../../Public/Header/Header';
import ReminderTypeList from './List';

const useStyles = makeStyles(() => ({
  margin: {
    margin: "0 0 0 10px",
  },
}));

const ReminderType = () => {

  const [tabListItem, setTabListItem] = useRecoilState(reminderTypeTabListState);
  const [tabIndex, setTabIndex] = useRecoilState(reminderTypeTabIndexState);

  const muiClasses = useStyles();

  //init Tab list when init
  useEffect(() => {
    setTabListItem([]);
    setTabIndex(0);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {

    if (tabListItem.length < tabIndex - 1) {

      setTabIndex(0);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabListItem, tabIndex]);

  const addTab = (item: IReminderType) => {

    const thisIndex = tabListItem.findIndex((i: IReminderType) => {
      if (i.ReminderTypeId === item.ReminderTypeId)
        return true;

      return false;
    });

    //if (searchTab.length == 0) {
    if (thisIndex < 0) {
      setTabListItem([...tabListItem, item]);
    }
    else {

      setTabIndex(thisIndex + 2);
    }
  };

  const removeTab = (removeItem: IReminderType) => {

    const filtered = tabListItem.filter((i: IReminderType) => {
      return i.ReminderTypeId !== removeItem.ReminderTypeId;
    });

    setTabListItem(filtered);
  };

  return (
    <ContentsWrapper header={<Header title="Reminder Type" />}>
      <div className="row no-gutters">
        <div className="col-md-12  mt-3">
          <div className="tab-content" id="myTabContent">
            <Tabs forceRenderTabPanel selectedIndex={tabIndex} onSelect={index => setTabIndex(index)}>
              <TabList>
                <Tab height="38" >Reminder Type</Tab>
                <Tab height="38" >Add </Tab>
                {
                  tabListItem?.map((item) =>
                    <Tab key={item.ReminderTypeId} height="38">
                      {item.Name}
                      <IconButton aria-label="delete" className={muiClasses.margin} size="small" onClick={() => removeTab(item)}>
                        <CancelIcon fontSize="inherit" />
                      </IconButton>
                    </Tab>
                  )
                }
              </TabList>
              <TabPanel>
                <ReminderTypeList addTab={addTab} />
              </TabPanel>
              <TabPanel>
                <ReminderTypeDetail item={undefined} />
              </TabPanel>
              {
                tabListItem?.map((item: IReminderType) => (
                  <TabPanel key={item.ReminderTypeId} headers={item.Name}>
                    <ReminderTypeDetail
                      item={item}
                    />
                  </TabPanel>
                ))
              }
            </Tabs>
          </div>
        </div>
      </div>
    </ContentsWrapper>
  );
};

export default ReminderType;